import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy, LogIn, UserPlus, LogOut, Home, User, Menu, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

function Header() {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const headerStyle = {
    background: 'linear-gradient(135deg, #013369 0%, #002244 100%)',
    borderBottom: '3px solid #D50A0A'
  };

  const handleLogout = () => {
    logout();
    setMobileMenuOpen(false);
    navigate('/');
  };

  const handleNavigation = (path) => {
    setMobileMenuOpen(false);
    navigate(path);
  };

  return (
    <header className="text-white shadow-xl" style={headerStyle}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div
            className="flex items-center space-x-2 md:space-x-3 cursor-pointer hover:opacity-90 transition-opacity"
            onClick={() => handleNavigation('/')}
          >
            <Trophy className="w-7 h-7 md:w-9 md:h-9 text-yellow-400 flex-shrink-0" />
            <div>
              <h1 className="text-lg md:text-2xl font-bold tracking-tight">Touchdown League</h1>
              <p className="text-xs opacity-90 hidden sm:block">Pronostique les marqueurs de TD</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-3">
            {!currentUser ? (
              <>
                <button
                  onClick={() => handleNavigation('/')}
                  className="flex items-center space-x-2 px-3 py-1.5 rounded-lg hover:bg-blue-950 transition text-sm"
                >
                  <Home className="w-4 h-4" />
                  <span>Accueil</span>
                </button>
                <button
                  onClick={() => handleNavigation('/login')}
                  className="flex items-center space-x-2 px-3 py-1.5 bg-red-800 rounded-lg hover:bg-blue-900 transition text-sm"
                >
                  <LogIn className="w-4 h-4" />
                  <span>Connexion</span>
                </button>
                <button
                  onClick={() => handleNavigation('/register')}
                  className="flex items-center space-x-2 px-3 py-1.5 bg-green-700 rounded-lg hover:bg-green-800 transition text-sm"
                >
                  <UserPlus className="w-4 h-4" />
                  <span>Inscription</span>
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => handleNavigation(currentUser.role === 'admin' ? '/admin' : '/player')}
                  className="flex items-center space-x-2 px-3 py-1.5 rounded-lg hover:bg-blue-950 transition text-sm"
                >
                  <User className="w-4 h-4" />
                  <span>Dashboard</span>
                </button>
                <button
                  onClick={handleLogout}
                  className="flex items-center space-x-2 px-3 py-1.5 bg-red-700 rounded-lg hover:bg-blue-900 transition text-sm"
                >
                  <LogOut className="w-4 h-4" />
                  <span>Déconnexion</span>
                </button>
              </>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-blue-950 transition"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-2 space-y-2 animate-fadeIn">
            {!currentUser ? (
              <>
                <button
                  onClick={() => handleNavigation('/')}
                  className="w-full flex items-center space-x-2 px-4 py-2.5 rounded-lg hover:bg-blue-950 transition text-sm"
                >
                  <Home className="w-5 h-5" />
                  <span>Accueil</span>
                </button>
                <button
                  onClick={() => handleNavigation('/login')}
                  className="w-full flex items-center space-x-2 px-4 py-2.5 bg-red-800 rounded-lg hover:bg-red-900 transition text-sm"
                >
                  <LogIn className="w-5 h-5" />
                  <span>Connexion</span>
                </button>
                <button
                  onClick={() => handleNavigation('/register')}
                  className="w-full flex items-center space-x-2 px-4 py-2.5 bg-green-700 rounded-lg hover:bg-green-800 transition text-sm"
                >
                  <UserPlus className="w-5 h-5" />
                  <span>Inscription</span>
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => handleNavigation(currentUser.role === 'admin' ? '/admin' : '/player')}
                  className="w-full flex items-center space-x-2 px-4 py-2.5 rounded-lg hover:bg-blue-950 transition text-sm"
                >
                  <User className="w-5 h-5" />
                  <span>Dashboard</span>
                </button>
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center space-x-2 px-4 py-2.5 bg-red-700 rounded-lg hover:bg-red-900 transition text-sm"
                >
                  <LogOut className="w-5 h-5" />
                  <span>Déconnexion</span>
                </button>
              </>
            )}
          </nav>
        )}
      </div>
    </header>
  );
}

export default Header;
